// Custom router scroll behavior.
//
// Global CSS sets `scroll-behavior: smooth` on `*`, which makes vue-router's
// default route-change scroll animate. During an SPA route swap (especially to
// pages that load their content async, e.g. /impact-v2/[impact_id]) that
// animation gets interrupted by the layout change and lands mid-page instead
// of at the top. Forcing `behavior: 'instant'` here overrides the CSS so route
// navigation always jumps straight to the top, while browser back/forward
// still restores the previous scroll position.
export default {
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, top: 0, behavior: 'instant' }
    return { left: 0, top: 0, behavior: 'instant' }
  }
}
